<template>
  <v-app light class="App">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
@import "./global.scss";
</style>
